import React from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import PermissionDecoratorV2 from '../../../components/utils/permission/PermissionDecoratorV2';
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
  Box,
} from '@mui/material';
import type { ApiReturnDataProcessorConfiguration } from '@highimpact-frontend/api-types';
import { useTranslation } from 'react-i18next';

/**
 * This component replace using GridActionsCellItem / GridActionsCell.
 * We implement our control button + MUI Menu, which replaces showInMenu
 * (creates a menu from actions, rather than simply displaying buttons
 * inside a cell).
 */

type RowMUI = {
  id: number;
  data: ApiReturnDataProcessorConfiguration;
};

interface AlertConfigCellProps {
  params: GridRenderCellParams<RowMUI>;
  onEdit: (config: ApiReturnDataProcessorConfiguration) => void;
  onDelete: (id: number) => void;
}

export default function AlertConfigCell({
  params,
  onEdit,
  onDelete,
}: AlertConfigCellProps) {
  const row = params.row;
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);
  const { t } = useTranslation(['commons']);

  const handleOpen = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  return (
    <Box className="mui-actions-cell">
      <IconButton size="small" onClick={handleOpen}>
        <MoreVertIcon fontSize="small" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={3}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            sx: {
              transform: 'translateX(-100%) !important',
            },
          },
        }}
      >
        <PermissionDecoratorV2 item={'alerts_configurations_edit_button'}>
          <MenuItem
            onClick={() => {
              handleClose();
              onEdit(row.data);
            }}
          >
            <ListItemIcon>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t('Modifier')}</ListItemText>
          </MenuItem>
        </PermissionDecoratorV2>

        <PermissionDecoratorV2 item={'alerts_configurations_delete_button'}>
          <MenuItem
            onClick={() => {
              handleClose();
              onDelete(row.id);
            }}
          >
            <ListItemIcon>
              <DeleteIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t('Supprimer')}</ListItemText>
          </MenuItem>
        </PermissionDecoratorV2>
      </Menu>
    </Box>
  );
}
